{
  "Clear search": "Tühjenda otsing"
}
